import {
  CardHeaderProps as ChakraCardHeaderProps,
  chakra,
  forwardRef,
  useMenuStyles,
} from '@chakra-ui/react';
import classnames from 'classnames';
import React from 'react';

import { OmitChakraProps } from '../../utils/typeUtils';

export type MenuHeaderProps = OmitChakraProps<ChakraCardHeaderProps>;

/**
 * Allows you to specify header content to a menu.
 *
 * Should be used as a sibling of the `MenuList` component.
 */
export const MenuHeader = forwardRef<MenuHeaderProps, 'div'>(
  ({ children, ...props }, ref) => {
    const styles = useMenuStyles();
    return (
      <chakra.header
        ref={ref}
        // eslint-disable-next-line tailwindcss/no-custom-classname
        className={classnames('orbit-menu__header', props.className)}
        __css={styles.header}
        {...props}
      >
        {children}
      </chakra.header>
    );
  },
);
